// extracted by mini-css-extract-plugin
module.exports = {"input":"MInput_input__26yI4"};